<div class="m-a-md">
    <app-data-list-command (filtersToApplyChange)="search($event.criteria)" [hidefilter]="true" [hideReload]="true">
        <div fxLayoutAlign="space-between center">
            <h5 class="m-a-0">{{ "moduleParameter.responseDays" | translate }}</h5>
            <div fxLayout fxLayoutAlign="center center">
                <button mat-icon-button (click)="getMappedData()" class="m-r-sm" [attr.aria-label]="'a11y.common.refresh' | translate">
                    <mat-icon aria-hidden="true">refresh</mat-icon>
                </button>
                <mat-form-field class="cipo-input p-0 m-r">
                    <mat-select (selectionChange)="filter($event)" value="0">
                        <mat-option value="0">
                            {{ "moduleParameter.all" | translate }}
                        </mat-option>
                        <mat-option value="1">
                            {{ "moduleParameter.onMenu" | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        @if (tableColumns) {
            <cipo-paged-data-list
                class="data-list"
                [tableColumns]="tableColumns"
                [tableData]="tableData"
                [loading]="loading"
                (rowClicked)="openSettingModal($any($event))"
                [options]="tableOptions" />
        }
    </app-data-list-command>
</div>
